import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function DigestSendButton() {
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);

  useEffect(() => { api.get("/digest/status").then((r) => setLast(r.data)).catch(() => {}); }, []);

  async function send() {
    if (!window.confirm("Email every parent last month's attendance and pending fees now? Parents who already got this month's summary are skipped.")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/digest/send-now");
      toast.success(`Parent summaries for ${data.month || "last month"} are being sent`);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="flex flex-col items-start sm:items-end">
      <Button data-testid="digest-send-now-btn" variant="outline" onClick={send} disabled={busy} className="border-violet-200 text-[color:var(--brand)] bg-white admin-dark-btn">
        {busy ? <Loader2 size={15} className="animate-spin mr-1.5" /> : <Mail size={15} className="mr-1.5" />} Send parent digest
      </Button>
      {last?.status && (
        <span data-testid="digest-last-run" className="text-[11px] text-slate-500 mt-1">
          Last run {last.month}: {last.status === "done" ? `${last.sent} sent, ${last.failed} failed` : last.status}
        </span>
      )}
    </div>
  );
}
